const announceRoutes = {
  index: {
    path: 'index.maneuver.announce',
    url: '/annoncer',
  },
  selectWagons: {
    path: 'index.maneuver.announce.wagon',
    url: '/selection-wagons',
  },
  report: {
    path: 'index.maneuver.announce.report',
    url: '/rapport',
  },
}

export default announceRoutes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/announce/routes.js